export class API {

  static url(method: string): string {
    return `/api/${method}`;
  }

}
